import { render } from "./TaxSettingsPagePage.vue?vue&type=template&id=a7387c50&ts=true"
import script from "./TaxSettingsPagePage.vue?vue&type=script&lang=ts"
export * from "./TaxSettingsPagePage.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\DDrive\\DeveloperFolder\\VueJsApps\\byihusemanagt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__